export const locale = {
    lang: "es",
    data: {
        MAP: {
            ShowDisabledDevices: "Mostrar dispositivos inactivos",
        },
    },
};
